import {
  NgModule,
  CUSTOM_ELEMENTS_SCHEMA,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";

import { HTTP_INTERCEPTORS } from "@angular/common/http";
import {
  HammerModule,
  HammerGestureConfig,
  HAMMER_GESTURE_CONFIG,
} from "@angular/platform-browser";
import * as Hammer from "hammerjs";

import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatBadgeModule } from "@angular/material/badge";
import { MatBottomSheetModule } from "@angular/material/bottom-sheet";
import { MatButtonModule } from "@angular/material/button";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatCheckboxModule } from "@angular/material/checkbox";
import {
  MatDialogModule,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { MatDividerModule } from "@angular/material/divider";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatRippleModule } from "@angular/material/core";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatSortModule } from "@angular/material/sort";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatStepperModule } from "@angular/material/stepper";
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTooltipModule } from "@angular/material/tooltip";

//import { AppModule } from '../app.module';
// import { MDToolsModule } from '../mdtools/mdtools.module';

import { PipeModule } from "../pipe/pipe.module";
import { OrgModule } from "../org/org.module";

//import { MDDialogModule } from '../dialog/md-dialog.module';
import { ActionPromptDialogComponent } from "../dialog/action-prompt/action-prompt.dialog";
import { FormDialogComponent } from "../dialog/form/form.dialog";

//import { AppRoutingModule } from '../app-routing.module';
//import { AuthInterceptor } from '../app.intercept';

// import { AuthService } from '../service/auth.service';
// import { NotifyQueueService } from '../service/notify-queue.service';

import { AuthorizationService } from "../service/authorization.service";
import { ToastrModule, ToastrService } from "ngx-toastr";
import { ToasterService } from "../service/toaster.service";
import { PlatformService } from "../service/platform.service";
import { DocumentService } from "../service/document.service";
import { HelpService } from "../service/help.service";
import { ValidationService } from "../service/validation.service";
import { GroupService } from "../service/group.service";
import { GroupMemberService } from "../service/group-member.service";
import { UserService } from "../service/user.service";
import { UserSubAccountService } from "../service/user-subaccount.service";
import { MailService } from "../service/mail.service";
import { OrganizationService } from "../service/organization.service";
import { OrgUserService } from "../service/orguser.service";

import { environment } from "../../environments/environment";

// import { MDCommonModule } from '../mdcommon.module';

import { GroupData } from "./model/groupdata.model";
export { GroupData } from "./model/groupdata.model";
import { GroupMember } from "./model/groupmember.model";
export { GroupMember } from "./model/groupmember.model";

import { GroupComponent } from "./group/group.component";
import { GroupListComponent } from "./group-list/group-list.component";
import { GroupFileListComponent } from "./group-file-list/group-file-list.component";

import { AddGroupMemberComponent } from "./add-group-member/add-group-member.component";
import { GroupMemberListComponent } from "./group-member-list/group-member-list.component";

import { GroupFileComponent } from "./group-file/group-file.component";
import { GroupTabComponent } from "./group-tab/group-tab.component";

// import { HelpDialogComponent } from '../dialog/help/help.dialog';

// const mgrRoutes = [{path: '', component: MdAppMgrComponent}];

@NgModule({
    imports: [
        //AppModule,
        CommonModule,
        OrgModule,
        PipeModule,
        // MDDialogModule,
        // RouterModule.forChild(mgrRoutes),
        FormsModule,
        ReactiveFormsModule,
        ToastrModule.forRoot({
            positionClass: "toast-center-center",
        }),
        HammerModule,
        MatAutocompleteModule,
        MatBadgeModule,
        MatBottomSheetModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatCheckboxModule,
        MatDialogModule,
        MatDividerModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatPaginatorModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatRippleModule,
        MatSortModule,
        MatSelectModule,
        MatSidenavModule,
        MatSlideToggleModule,
        MatStepperModule,
        MatToolbarModule,
        MatTabsModule,
        MatTableModule,
        MatTooltipModule,
        AddGroupMemberComponent,
        GroupComponent,
        GroupListComponent,
        GroupFileComponent,
        GroupFileListComponent,
        GroupMemberListComponent,
        GroupTabComponent,
    ],
    exports: [
        AddGroupMemberComponent,
        GroupComponent,
        GroupListComponent,
        GroupFileComponent,
        GroupFileListComponent,
        GroupMemberListComponent,
        GroupTabComponent,
    ],
    providers: [
        /***
            AuthService,
            {
                provide: HTTP_INTERCEPTORS,
                useClass: AuthInterceptor,
                multi: true
            },
            ***/
        { provide: HAMMER_GESTURE_CONFIG, useClass: HammerGestureConfig, deps: [] },
        AuthorizationService,
        DocumentService,
        GroupService,
        GroupMemberService,
        HelpService,
        MailService,
        { provide: MatDialogRef, useValue: {} },
        { provide: MAT_DIALOG_DATA, useValue: {} },
        OrganizationService,
        OrgUserService,
        ToasterService,
        ToastrService,
        // NotifyQueueService,
        UserService,
        UserSubAccountService,
        ValidationService,
    ],
})
export class GroupModule {}
